export default __webpack_public_path__ + "static/media/T62.4be2c9d1.JPG";